import React, { useReducer, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

// import Picture from '@components/Picture';
import { Picture } from '@ui';
import iconsList from '@ui-kit-icons';
import { Link } from '@compat/router';

const defaultParams = {
  size: 'small',
  type: 'btn',
  colour: 'red',
  rank: 'secondary',
  state: 'default',
  link: null,
  text: 'Кнопка'
};

// TODO
// прописать иконку для counter(hover, disabled)

const Button = props => {
  // style
  let marginLeft = '8px';
  let heightIcon = '24px';
  let widthAmount = '58px';
  let className = 'buttonUI ';

  const initialHoveredState = {
    isHovered: false,
    isHoveredMinus: false,
    isHoveredPlus: false,
    isDisabled: false
  };
  const reducer = (hoveredState, action) => {
    switch (action.type) {
      case 'hover':
        return {
          ...hoveredState,
          isHovered: action.payload
        };
      case 'hoverPlus':
        return {
          ...hoveredState,
          isHoveredPlus: action.payload
        };
      case 'hoverMinus':
        return {
          ...hoveredState,
          isHoveredMinus: action.payload
        };
      case 'disabled':
        return {
          ...hoveredState,
          isDisabled: action.payload
        };
      default:
        throw new Error();
    }
  };
  const [hoveredState, dispatch] = useReducer(reducer, initialHoveredState);
  const { isHovered, isHoveredMinus, isHoveredPlus, isDisabled } = hoveredState;

  const hoverFunc = (type, payload) => () => {
    dispatch({ type, payload });
  };

  const [amount, setAmount] = useState(props.amount);

  useEffect(() => {
    setAmount(props.amount);
    hoverFunc('disabled', props.amount <= 1)();
  }, [props.amount]);

  /**
   * ЭТАП 2 (SSR): содержимое кнопки РАНЬШЕ жило в стейте и заполнялось
   * эффектом (useState([]) + useEffect(createContent)). На сервере эффекты
   * не выполняются, поэтому SSR отдавал кнопку ПУСТОЙ — цветной прямоугольник
   * без текста, — а надпись появлялась только после гидрации. Поймано на
   * «Выбрать подарки» (/opt), но Button общий, так что пустыми приезжали ВСЕ
   * кнопки на всех страницах. Теперь содержимое считается прямо в рендере:
   * сервер и клиент дают одинаковую разметку.
   *
   * Побочно чинится старый баг: в списке зависимостей того эффекта не было
   * `text` и `contentIcons`, поэтому смена подписи кнопки на лету не
   * применялась.
   */

  const onClickMinus = () => {
    if (amount > 1 || props.withoutCounterDis) {
      setAmount(amount - 1);
      hoverFunc('disabled', amount - 1 <= 1)();
      props.onClickMinus();
    }
  };

  const onClickPlus = () => {
    setAmount(amount + 1);
    hoverFunc('disabled', amount + 1 <= 1)();
    props.onClickPlus();
  };

  const {
    // classname
    type = defaultParams.type,
    size = defaultParams.size,
    state = defaultParams.state,
    colour = defaultParams.colour,
    rank = defaultParams.rank,
    // htmlcontent && styleContent
    contentIcons,
    text = defaultParams.text,
    fullWidth,
    onClick
  } = props;

  if (size === 'small' || size === 'extraSmall') {
    marginLeft = '6px';
    heightIcon = '16px';
    widthAmount = '54px';
  }

  const buildContent = () => {
    let content = [];
    if (type === 'btn&&Icon') {
      const leftPart = contentIcons.find(item => item.side === 'left');
      if (leftPart) {
        content.push(
          <Picture
            icon={leftPart.icon}
            iconHover={leftPart.iconHover}
            height={heightIcon}
            width={heightIcon}
            isHovered={isHovered}
          />
        );
      }

      content.push(text);

      const rightPart = contentIcons.find(item => item.side === 'right');
      if (rightPart) {
        content.push(
          <Picture
            icon={iconsList[rightPart.icon]}
            iconHover={iconsList[rightPart.iconHover]}
            height={heightIcon}
            width={heightIcon}
            isHovered={isHovered}
          />
        );
      }
    } else if (type === 'btn') {
      content.push(text);
    } else if (type === 'icon') {
      content.push(
        <Picture
          icon={iconsList[contentIcons[0].icon]}
          iconHover={iconsList[contentIcons[0].iconHover]}
          height={heightIcon}
          width={heightIcon}
          isHovered={isHovered}
        />
      );
    } else if (type === 'counter') {
      const { minus, minusHovered, plus, plusHovered } = iconsList;

      content = [
        <Picture
          key='picture-1'
          className={isDisabled && !props.withoutCounterDis ? 'disabled' : ''}
          onMouseEnter={hoverFunc('hoverMinus', true)}
          onMouseLeave={hoverFunc('hoverMinus', false)}
          onClick={onClickMinus}
          icon={minus}
          iconHover={minusHovered}
          iconDisabled={minusHovered}
          height={heightIcon}
          width={heightIcon}
          isHovered={isHoveredMinus}
          isDisabled={isDisabled && !props.withoutCounterDis}
        />,
        amount,
        <Picture
          key='picture-2'
          onMouseEnter={hoverFunc('hoverPlus', true)}
          onMouseLeave={hoverFunc('hoverPlus', false)}
          onClick={onClickPlus}
          icon={plus}
          iconHover={plusHovered}
          iconDisabled={plusHovered}
          height={heightIcon}
          width={heightIcon}
          isHovered={isHoveredPlus}
          isDisabled={false}
        />
      ];
    }

    return content;
  };

  const content = buildContent();

  className += `${[
    size,
    colour,
    rank,
    state,
    type,
    fullWidth ? 'fullWidth' : ''
  ].join(' ')}`;

  const createStyle = (item, index) => ({
    marginLeft: index ? marginLeft : '0px',
    width: type === 'counter' && index === 1 ? widthAmount : 'auto'
  });

  const options = {
    onClick,
    onMouseEnter: hoverFunc('hover', true),
    onMouseLeave: hoverFunc('hover', false),
    className,
    ...(props.btnProps || {})
  };

  if (props.link) {
    return (
      <Link {...options} to={props.link}>
        {content.map((item, index) => (
          <span key={index} style={createStyle(item, index)}>
            {item}
          </span>
        ))}
      </Link>
    );
  }

  return (
    <button {...options}>
      {content.map((item, index) => (
        <span key={index} style={createStyle(item, index)}>
          {item}
        </span>
      ))}
    </button>
  );
};

Button.propTypes = {
  btnProps: PropTypes.object,
  // style
  link: PropTypes.string,
  fullWidth: PropTypes.bool,
  type: PropTypes.oneOf(['btn', 'icon', 'btn&&Icon', 'counter']),
  size: PropTypes.oneOf(['large', 'normal', 'medium', 'small', 'extraSmall']),
  state: PropTypes.oneOf(['default', 'hover', 'disabled']),
  colour: PropTypes.oneOf(['red', 'grey', 'green']),
  rank: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

  // content
  text: PropTypes.node,
  contentIcons: PropTypes.arrayOf(
    PropTypes.shape({
      side: PropTypes.string,
      icon: PropTypes.string.isRequired,
      iconHover: PropTypes.string.isRequired
    })
  ),
  withoutCounterDis: PropTypes.bool,

  // functions
  onClick: PropTypes.func,
  onClickMinus: PropTypes.func,
  onClickPlus: PropTypes.func
};

export default Button;
